import { Component, Input } from '@angular/core';
import { FormPopupComponent } from '../form-popup/form-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../services/common.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';

import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { MatButton } from '@angular/material/button';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { EditorTextComponent } from '../../../home/editor-text/editor-text.component';

@Component({
  selector: 'calsoft-button-type1',
  imports: [DefaultLayoutDirective,EditorTextComponent, DefaultLayoutAlignDirective, MatButton, DefaultStyleDirective],
  templateUrl: './button-type1.component.html',
  styleUrl: './button-type1.component.scss'
})
export class ButtonType1Component {

    @Input() item: any;
    @Input() data: any; 
  customField1:any;
  fontFamily: string|any ; 

  public serverPath = environment.commonImageApi + '/home/';

  ngOnInit() {
    
    
        this.router.events
          .pipe(filter((event:any) => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            const url = (event as NavigationEnd).urlAfterRedirects || event.url;
          });
  }

  constructor(
      public dialog: MatDialog,
      private commonService:CommonService,
      public router: Router
  ) {

  }

  link(url:any) {

    window.open(url, '_blank')



  }
  

  callToFunction(type:any,value:any){

 this.commonService.navigateButton(type,value)
  // this.commonService.goToLink('contact-us')

}

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      window.open(fullURL, '_blank');


    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

active: string|any;
scrollDown(value:any){
  this.active =value;
  this.ScrollIntoView(this.active);
}

ScrollIntoView(elem: string) {
  this.active = "#" + elem;
  const ele = document.querySelector(this.active) as HTMLElement;
  
  if (ele) {
    const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
    const paddingTop = 96;
    window.scrollTo({
    top: offsetTop - paddingTop,
    behavior: 'smooth'
    });
  } else {
    console.error('Element not found:', this.active);
  }
  }


  navigateToConnect() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

 dynamicFormPopup(formGroupId:any) {
   if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(FormPopupComponent, {
         width: '790px',
         data: { formId: formGroupId}
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe((result:any) => {

      });

   }
   else {
      let dialogRef = this.dialog.open(FormPopupComponent, {
         minWidth: '100vw', height: '100vh',
         data: { formId: formGroupId}
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe((result:any) => {

      });
   }

}


}
